/* SeatFit URL params: the shopper's picks live in the page link (?year&make&model&body&s2 ... &gen&set&seat&color&style),
 * so a copied link restores the exact choice. Loaded `defer` after seatfit-core-resolve.js and before
 * seatfit-core-rules.js by snippets/seatfit-config.liquid. */
(function () {
  'use strict';
  var SF = window.SeatFit;
  if (!SF) { console.warn('[SeatFit] seatfit-core.js must load before seatfit-core-url-params.js'); return; }
  if (SF.readParams) return; // second copy of the tag

  var slugify = SF.slugify, toYear = SF.toYear, seatSlugs = SF.seatSlugs;
  // style: the product's Style option value (Classic / Diamond ...), so an ad can open one look.
  var SLUG_KEYS = ['make', 'model', 'body', 's2', 's3', 'gen', 'color', 'style'];
  // URL param of step 1, 2, 3 ...: seats use three at most; covers and mats name up to seven steps on one truck
  // (Silverado mats: Cab, Body, Shifter Type, Under Seat Storage Box, Floor Type, Floor Mat Set, 1st Row Seats).
  var STEP_PARAMS = ['body'];
  for (var n = 2; n <= 12; n++) STEP_PARAMS.push('s' + n);

  function readParams() {
    var sp = new URLSearchParams(location.search);
    var out = { year: toYear(sp.get('year')) };
    // Ad links may carry display names (make=Mercedes-Benz); everything is compared as slugs.
    SLUG_KEYS.forEach(function (k) { out[k] = slugify(sp.get(k)) || null; });
    var set = slugify(sp.get('set'));
    out.set = SF.SETS.indexOf(set) >= 0 ? set : null;
    out.seat = seatSlugs(sp.get('seat')) || null;
    // Steps past the third only when the link has them, so a seat link reads back exactly as it always did.
    STEP_PARAMS.slice(3).forEach(function (k) { var v = slugify(sp.get(k)); if (v) out[k] = v; });
    return out;
  }

  // replaceState: picking a step adds no Back-button entry; params we do not own (variant, utm_*, fbclid) stay.
  function writeParams(partial) {
    try {
      var url = new URL(location.href);
      Object.keys(partial || {}).forEach(function (k) {
        var v = partial[k];
        if (k === 'year') v = toYear(v);
        else if (k === 'seat') v = seatSlugs(v);
        else if (v != null) v = slugify(v);
        if (v == null || v === '') url.searchParams.delete(k);
        else url.searchParams.set(k, String(v));
      });
      var next = url.pathname + url.search + url.hash;
      if (next !== location.pathname + location.search + location.hash) history.replaceState(history.state, '', next);
    } catch (e) { console.warn('[SeatFit] could not update the URL', e); }
  }

  Object.assign(SF, { STEP_PARAMS: STEP_PARAMS, readParams: readParams, writeParams: writeParams });
})();
